module.exports = __webpack_public_path__ + "img/logo-help-white.0bc744cf.png";